import { Payeeaccountinfo } from "./Payeeaccountinfo";

export class Stmttrn{
    constructor(){}
    Benefit:string = null;
    // Payeeaccountinfo: Payeeaccountinfo[] = null;
    Payeeaccountinfo: Payeeaccountinfo = null;
    Trnamt: number = null;
    Purpose: string =  null;
    Purposecode: string = null;
    Payeerefnumber: string = null;

    Deserialize(input:any){
        this.Benefit = input.benefit._text;
        // if (input.payeeaccountinfo!=null){
        //     this.Payeeaccountinfo=[];
        //     this.Payeeaccountinfo.push(new Payeeaccountinfo().Deserialize(input.payeeaccountinfo));
            
        // }
        this.Payeeaccountinfo = new Payeeaccountinfo().Deserialize(input);
        this.Trnamt = parseFloat(input.trnamt._text);
        this.Purpose = input.purpose._text;
        this.Purposecode = input.purposecode._text;
        this.Payeerefnumber = input.payeerefnumber._text;

        return this;
    }
}